import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { FileInputType } from '../enums';

export function listPatternValidator(pattern: RegExp): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const list = control.value as string[];

    if (!Array.isArray(list)) return null;

    for (const item of list) {
      if (!pattern.test(item)) return { noMatch: true };
    }

    return null;
  };
}

export function filesTypeValidator(
  filesControl: AbstractControl,
  acceptedType: FileInputType,
): ValidatorFn {
  return (): ValidationErrors | null => {
    const files: File[] = filesControl.value;
    const regex = new RegExp(`${acceptedType}$`, 'i');

    if (!files?.length) return null;

    if (files.some((f) => !regex.test(f.name))) return { filesType: true };

    return null;
  };
}

export function filesSizeValidator(filesControl: AbstractControl, maxSize: number): ValidatorFn {
  return (): ValidationErrors | null => {
    const files: File[] = filesControl.value;
    const maxSizeInBytes = maxSize * 1000 * 1000;

    if (!files?.length) return null;

    if (files.some((f) => f.size > maxSizeInBytes)) return { filesSize: true };

    return null;
  };
}
